import{useContext}from"react";import{UseDatabaseQueryContext}from"../../contexts/use-database-query.context.js";function useDatabaseQueryContext(props){return useContext(UseDatabaseQueryContext)(props)}export{useDatabaseQueryContext};
